module.exports = __webpack_public_path__ + "img/icon_download_excel.1d5a26d4.svg";